<template>
  <div class="address">
      <div class="address-header">
        <h3 class="address-title">目的地</h3>
        <div class="line-bold"></div>
      </div>
      <div class="address-sub-title">
          100+优选目的地供您选择
      </div>
      <div class="address-main">
          <img :src="MapImg3" class="map-img" alt="">
          <div class="map" v-for="(item, index) in maps" :key="index" :style="{left: item.left+'px', top: item.top+'px', right: item.right+'px', bottom: item.bottom+'px'}" @click="goRouterLists">
              <img :src="item.path" alt="">
          </div>
      </div>
  </div>
</template>

<script>
import MapImg3 from '@/assets/img/map4.png'
import Africa from '@/assets/img/Africa-blue.png'
import America from '@/assets/img/America-blue.png'
import Antarctica from '@/assets/img/Antarctica-blue.png'
import Arctic from '@/assets/img/Arctic-blue.png'
import Asia from '@/assets/img/Asia-blue4.png'
import SouthAmerica from '@/assets/img/South-America-blue.png'
import Europe from '@/assets/img/Europe-blue.png'
import TripolersLogo from '@/assets/img/tripolers-logo.png'
import dayang from '@/assets/img/dayang.png'
export default {
  name: 'Address',
  data () {
    return {
      MapImg3,
      maps: [
        {
          path: Africa,
          left: 533,
          top: 272,
          right: '',
          bottom: ''
        },
        {
          path: America,
          top: 6,
          left: '',
          right: '',
          bottom: ''
        },
        {
          path: Antarctica,
          top: '',
          left: 137,
          right: '',
          bottom: -55
        },
        {
          path: Arctic,
          top: 3,
          left: 336,
          right: '',
          bottom: ''
        },
        {
          path: Asia,
          top: 190,
          left: '',
          right: 104,
          bottom: ''
        },
        {
          path: SouthAmerica,
          top: 327,
          left: 272,
          right: '',
          bottom: ''
        },
        {
          path: Europe,
          top: 18,
          left: '',
          right: 0,
          bottom: ''
        },
        {
          path: TripolersLogo,
          top: '',
          left: 0,
          right: '',
          bottom: 164
        },
        {
          path: dayang,
          top: 440,
          left: 987,
          right: 142,
          bottom: 195
        }
      ]
    }
  },
  methods: {
    goRouterLists: function () {
      this.$router.push({
        path: '/routerLists?id=1'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.address {
    width: 1280px;
    margin: 50px auto 0;
    .address-header {
        width: 780px;
        border-bottom: 1px solid #dae1e6;
        margin: 0 auto;
        position: relative;
        padding-bottom:8px;
    }
    .address-title {
        width: 100%;
        text-align: center;
        font-weight: bold;
        font-size: 34px;
        color: #60676d;
    }
    .line-bold {
        width: 44px;
        height: 3px;
        position: absolute;
        left: 50%;
        bottom: -2px;
        margin-left: -22px;
        background: #0080cc;
    }
    .address-sub-title {
        width: 100%;
        text-align: center;
        color: #a3abb2;
        font-size: 16px;
        margin-top: 10px;
    }
    .address-main {
        width: 1280px;
        height: 760px;
        margin: 10px auto 0;
        overflow: hidden;
        position: relative;
        .map-img {
            width: 100%;
            height: 758px;
        }
        .map {
            position: absolute;
            z-index: 1030;
            cursor: pointer;
            img {
                width: 100%;
                height: 100%;
                opacity: 0;
                transition: opacity 0.3s;
                &:hover {
                    opacity: 1;
                    transition: opacity 0.3s;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/address.vue